import { render, staticRenderFns } from "./ProfessionalOrganizationReview.vue?vue&type=template&id=26aada98&scoped=true"
import script from "./ProfessionalOrganizationReview.vue?vue&type=script&lang=js"
export * from "./ProfessionalOrganizationReview.vue?vue&type=script&lang=js"
import style0 from "./ProfessionalOrganizationReview.vue?vue&type=style&index=0&id=26aada98&prod&scoped=true&lang=css"
import style1 from "./ProfessionalOrganizationReview.vue?vue&type=style&index=1&id=26aada98&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26aada98",
  null
  
)

export default component.exports